// extracted by mini-css-extract-plugin
export default {"deletedRowPlaceholder":"deletedRowPlaceholder---H7etB","deletedRowUndoButton":"deletedRowUndoButton---sDHFY"};